/* DON'T EDIT THIS FILE: edit original and run build again */ import {
  UserPrivateProfile,
  UserProfile,
} from "../../framework/auth-profile/schema.ts";
import { RolesMap } from "../../framework/permission/schema.ts";
import { userHasPermission } from "../../framework/permission/user-has-permission.ts";
import {
  getAllTenantCodes,
  TenantIndex,
} from "../../framework/tenant-collection/tenant-index-entry.ts";
import {
  canChangeToAllowedTenant,
  canChangeToAnyTenant,
} from "../../framework/tenant-permissions/permissions.ts";

export enum AllowedTenantsType {
  All = "all",
  Some = "some",
  OnlyCurrent = "onlyCurrent",
}

type AllowedTenants =
  | [AllowedTenantsType.All]
  | [AllowedTenantsType.OnlyCurrent]
  | [AllowedTenantsType.Some, string[]];

export const getAllowedTenants = ({
  roles,
  privateProfile,
}: {
  roles: RolesMap;
  privateProfile: UserPrivateProfile;
}): AllowedTenants => {
  if (userHasPermission(roles, canChangeToAnyTenant)) {
    return [AllowedTenantsType.All];
  }
  if (
    userHasPermission(roles, canChangeToAllowedTenant) &&
    privateProfile?.allowedTenants
  ) {
    return [AllowedTenantsType.Some, privateProfile.allowedTenants];
  }
  return [AllowedTenantsType.OnlyCurrent];
};

export const getResolvedAllowedTenants = (
  tenantIndex: TenantIndex,
  roles: RolesMap,
  privateProfile: UserPrivateProfile,
  currentTenant: string
): string[] => {
  const [allowedTenantsType, allowedTenants] = getAllowedTenants({
    roles,
    privateProfile,
  });
  if (allowedTenantsType === AllowedTenantsType.All) {
    return getAllTenantCodes(tenantIndex);
  } else if (allowedTenantsType === AllowedTenantsType.Some) {
    return allowedTenants;
  } else {
    // current tenant is not relevant here, as this list is used to jump to other tenants
    return [currentTenant];
  }
};

export const isTenantAllowed = (
  {
    roles,
    profile,
    privateProfile,
  }: {
    roles: RolesMap;
    profile: UserProfile;
    privateProfile: UserPrivateProfile;
  },
  tenant: string
) => {
  // eslint-disable-next-line no-restricted-properties
  if (profile?.tenant === tenant) {
    return true;
  }
  const [allowedTenantsType, allowedTenants] = getAllowedTenants({
    roles,
    privateProfile,
  });
  if (allowedTenantsType === AllowedTenantsType.All) {
    return true;
  }
  if (allowedTenantsType === AllowedTenantsType.Some) {
    return allowedTenants.includes(tenant);
  }
  return false;
};

// TEMP. until tenant select is fixed
export const canAccessTenant = (profile?: UserProfile, tenant?: string) =>
  // eslint-disable-next-line no-restricted-properties
  tenant && profile?.tenant === tenant;
